module.exports = __webpack_public_path__ + "static/media15-3f4b7deb3039918d733804cbe1dc88f6.png";